import { motion } from "framer-motion";
import Button from "./Button";
import { Categories } from "../../utils/categories";
import {  FoodCategory } from "../../../types";
import { BiRestaurant } from "react-icons/bi";

const Filters = ({filter, setFilter}: {filter:string, setFilter: any}) => {

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className={`w-full py-8 mb-6 flex justify-center`}
    >
      <div className="flex flex-wrap items-center justify-center gap-4 md:gap-5 px-4 max-w-6xl">
        {
            Categories.filter(cat => cat.name !== "").map((category: FoodCategory, index) =>{
                return (
                  <motion.div
                    key={category.id}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.05, duration: 0.3 }}
                  >
                    <Button category={category} filter={filter} setFilter={setFilter} />
                  </motion.div>
                )
            })
        }
      </div>
    </motion.div>
  );
};

export default Filters;
